import Vue from "vue";

export default {
  namespaced: true,
  state: {
    files: [],
    uploadedFiles: [],
  },
  getters: {
    files: (state) => state.files,
    uploadedFiles: (state) => state.uploadedFiles,
  },
  mutations: {
    SET_FILES(state, payload) {
      state.files = payload
    },
    DELETE_FILES(state, key) {
      state.files.splice(key, 1);
    },
    RESET_FILES(state) {
      state.files = []
    },

    SET_UPLOADED_FILES(state, payload) {
      const data = []
      Object.keys(payload).map(function (key) {
        let type = payload[key].type
        data[type] = data[type] || []
        data[payload[key].type].push(payload[key])
      });
      state.uploadedFiles = data
    },
    DELETE_UPLOADED_FILE(state, {type, key}) {
      state.uploadedFiles[type].splice(key, 1)
    },
    DELETE_UPLOADED_FILES(state) {
      state.uploadedFiles = []
    },
  },
  actions: {
    async uploadFiles({commit, dispatch}, {type, files, application_id}) {
      commit('context/ENABLE_LOADING', null, {root: true})
      commit("SET_FILES", files)

      let formData = new FormData();
      formData.set('type', type);
      if (application_id) {
        formData.set('application_id', application_id);
      }

      if (files.length > 0) {
        for (let i = 0; i < files.length || 0; i++) {
          formData.append('file[' + i + ']', files[i]);
        }
      } else {
        formData.append('file[0]', files);
      }

      await Vue.axios.post('/files/', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(() => {
          if (application_id) {
            if (type === 99 || type === 104) {
              commit("application/CHANGE_APPLICATION", {
                is_work: true,
                is_reject: true,
                is_done: false,
              }, {root: true})
              dispatch("application/updateApplication", null, {root: true})
            }

            dispatch('loadUploadedFilesByApplication', application_id)
          } else {
            dispatch('loadUploadedFiles')
          }
          commit('RESET_FILES')
          commit('context/DISABLE_LOADING', null, {root: true})
        })
        .catch((error) => {
          dispatch('django/handleError', {error}, {root: true})
          commit('context/DISABLE_LOADING', null, {root: true})
        })
    },
    async loadUploadedFilesByApplication({commit}, id) {
      await Vue.axios.get('/files/', {params: {application_id: id}})
        .then((response) => {
          commit('SET_UPLOADED_FILES', response.data)
        })
    },
    async loadUploadedFiles({commit}) {
      await Vue.axios.get('/files/')
        .then((response) => {
          commit('SET_UPLOADED_FILES', response.data)
        })
    },
    async loadFilesByApplication({commit}, id) {
      await Vue.axios.get('/application/files/', {params: {application_id: id}})
        .then((response) => {
          commit('SET_UPLOADED_FILES', response.data)
        })
    },
    async deleteFile({commit, state}, {type, key}) {
      const {id} = state.uploadedFiles[type][key]
      await Vue.axios.delete('/files/destroy/', {params: {id: id}})
        .then(() => {
          commit('DELETE_UPLOADED_FILE', {type: type, key: key})
        })
    }
  }
}
